import { computed, inject } from 'vue'
import { accessCodes, userServiceKey } from '@gat-ship/types'

export function useCreatePortcallPermissions() {
  const userService = inject(userServiceKey)

  const isAdmin = computed(() => userService?.isTenantAdmin.value ?? false)

  const canAddClient = computed(
    () =>
      userService?.hasPermission(
        accessCodes.system.stakeholder.addStakeholder
      ) ?? false
  )

  return {
    canManagePorts: isAdmin,
    canManageAgencies: isAdmin,
    canManageCallTypes: isAdmin,
    canAddClient
  }
}
